@if (isShowTitle) {
  <div class="note-field-label">{{ title || 'Notes' }}</div>
}

<div class="note-field-wrapper" [class.disabled]="disabled" [class.error]="errors">
  <ng-content></ng-content>
</div>

<div class="note-attention">Do not enter the card/account details in notes</div>

@if (errors && errors.isEmptySpaces) {
  <div class="note-validation-error">
    {{ errors && errors.isEmptySpaces.message }}
  </div>
}
